import { Modal } from "react-bootstrap";
import CancelIcon from "@material-ui/icons/Cancel";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import { InputAdornment, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import config from "../../config";
import { useSelector } from "react-redux";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";

const month = [
  { long: "January", short: "JAN" },
  { long: "Febrary", short: "FEB" },
  { long: "March", short: "MAR" },
  { long: "April", short: "APR" },
  { long: "May", short: "MAY" },
  { long: "June", short: "JUN" },
  { long: "July", short: "JUL" },
  { long: "August", short: "AUG" },
  { long: "September", short: "SEP" },
  { long: "October", short: "OCT" },
  { long: "November", short: "NOV" },
  { long: "December", short: "DEC" },
];
const CouponModal = ({ open = false, onClose = () => {} }) => {
  const [promoCode, setPromoCode] = useState("");
  const [couponList, setCouponList] = useState([]);
  const country = useCountry();
  const currencyFormatter = useCurrency();
  const shopDetails = useSelector((state) => state.shopDetails);
  const {
    footerData: { coupon = {} },
    removeCoupon = () => {},
    applyCoupon = () => {},
  } = useFooterData();
  const fetchCoupons = async () => {
    var res = await fetch(
      `${config.newApiGateway}/coupon/create-Update-delete-get-coupon`,
      {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          action: "getAllCoupon",
          shopId: shopDetails.shopId,
        }),
      }
    );
    res = await res.json();
    if (res.code === "ERROR") {
      setCouponList([]);
      return;
    }
    if (res.code === "SUCCESS") {
      setCouponList(res.data);
    }
  };
  useEffect(() => {
    if (shopDetails.shopId) {
      fetchCoupons();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopDetails.shopId]);
  return (
    <Modal
      scrollable={true}
      show={open}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => {
        onClose();
        //   setPromoCode("");
      }}
      style={{ padding: 0, margin: 0 }}
    >
      <Modal.Header>
        <div>
          <button
            className="closebutton"
            onClick={() => {
              onClose(false);
              // setPromoCode("");
            }}
          >
            <CancelIcon />
          </button>
          <div
            className="couponheading"
            style={{ marginTop: 20, marginBottom: 5 }}
          >
            <div>
              <LocalOfferIcon style={{ fontSize: 20 }} />
            </div>
            <h3>Apply Coupons</h3>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body
        style={{
          background: "#f5f9fc",
          maxHeight: "calc(100vh - 210px)",
          overflowY: "auto",
        }}
      >
        {couponList.length > 0 ? (
          <>
            {couponList.map((data) => (
              <div key={data.couponId} className="cardContainer">
                <div className="cardDataContainer">
                  <div className="couponCodeStyle">
                    <p>{data.promocode}</p>
                  </div>
                  <div className="coupounHeading">
                    <p>Get</p>
                  </div>
                  {data.discountType === "flat" ? (
                    <div className="couponOfferText">
                      <p>
                        {country.CurrencySymbol}
                        {data.discountAmount} OFF
                      </p>
                    </div>
                  ) : (
                    <div className="couponOfferText">
                      <p>{data.discountAmount}% OFF</p>
                    </div>
                  )}
                  <div className="applyAndButton">
                    <div className="applyTextStyle">
                      <p className="couponApplyPurchase">
                        Apply on purchase worth{" "}
                        {currencyFormatter(data.condition.minPrice)} or more
                      </p>
                      <p className="couponApplyValid">
                        Valid from{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {new Date(data.startDate).getDate() +
                            " " +
                            month[new Date(data.startDate).getMonth()].short +
                            " " +
                            new Date(data.startDate).getFullYear()}
                        </span>{" "}
                        to{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {new Date(data.expiryDate).getDate() +
                            " " +
                            month[new Date(data.expiryDate).getMonth()].short +
                            " " +
                            new Date(data.expiryDate).getFullYear()}
                        </span>
                      </p>
                    </div>
                    <div className="applyBtnStyle">
                      {Object.keys(coupon).length > 0 &&
                      coupon.couponId === data.couponId ? (
                        <button
                          className="couponApplyBtn"
                          onClick={() => {
                            removeCoupon();
                          }}
                        >
                          Remove
                        </button>
                      ) : (
                        <button
                          className="couponApplyBtn"
                          onClick={() => applyCoupon(data)}
                        >
                          Apply
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="couponSaveCoupon">
                    <p>
                      You will save
                      {data.discountType === "flat" ? (
                        <> {currencyFormatter(data.discountAmount)}</>
                      ) : (
                        <> {data.discountAmount}%</>
                      )}{" "}
                      with this coupon
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div
            className="cardContainer"
            style={{ textAlign: "center", marginTop: "20px", opacity: "0.5" }}
          >
            <p>No Coupons To Show</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CouponModal;
